import { AvatarMap } from './AvatarMap';

const randomNames = [
    'Mystic', 'Shadow', 'Echo', 'Blaze', 'Luna', 'Nova', 'Sky', 'Zephyr', 'Raven',
    'Vortex', 'Nebula', 'Drift', 'Vibe', 'Frost', 'Phantom', 'Wraith', 'Dusk',
    'Haze', 'Storm', 'Rogue', 'Pulse', 'Ember', 'Flicker', 'Shade', 'Bolt', 'Glimmer',
    'Surge', 'Flare', 'Cosmo', 'Daze', 'Sable', 'Nyx', 'Rift', 'Glow', 'Specter',
    'Chill', 'Havoc', 'Mist', 'Stryke', 'Zest', 'Dawn', 'Volt', 'Crimson', 'Slate',
    'Kaze', 'Fury', 'Vapor', 'Glint', 'Rebel', 'Ash', 'Tide', 'Zenith', 'Dagger',
    'Star', 'Nerve', 'Blitz', 'Shadez', 'Flux', 'Neon', 'Chaos', 'Verve', 'Rush',
    'Grit', 'Faze', 'Drip', 'Hex', 'Jolt', 'Wisp', 'Scorch', 'Vex', 'Hype', 'Frosty',
    'Slash', 'Glaze', 'Sparkz', 'Eclipse', 'Raze', 'Sway', 'Phantomz', 'Buzz', 'Quartz',
    'Vivid', 'RUSH', 'Craze', 'Driftz', 'Ignite', 'Zest', 'Frenzy', 'Spectral', 'BlazeX',
    'Vaporz', 'Sting', 'Aurora', 'Kryo'
];

export const getAnonymousName = (uid) => {
    if (!uid) return 'Anonymous';
    const nameIdx = uid.split('').reduce((s, c) => s + c.charCodeAt(0), 0) % randomNames.length;
    return randomNames[nameIdx];
};

export const getAvatarForShadow = (name) => {
    return AvatarMap[name] || null;
};
